(function() { window.GUID_5a640a9b_5cf5_49bf_a0ae_8dbc1733342f = { getGuid: function() { return "5a640a9b-5cf5-49bf-a0ae-8dbc1733342f"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class MatchesSection {
                        static get instance() {
                            if (!MatchesSection._instance)
                                MatchesSection._instance = new MatchesSection();
                            return MatchesSection._instance;
                        }
                        static get filtersAreCollapsed() {
                            const { instance } = MatchesSection;
                            return instance._filtersAreCollapsed;
                        }
                        static get isWallLayout() {
                            return $("#MatchesV2WallLayout").val() == "True";
                        }
                        constructor() {
                            this._filtersAreCollapsed = true;
                            this._observers = [];
                        }
                        static setObservers(accordion) {
                            const { instance } = this;
                            MatchesSection.clearObservers();
                            const $filters = accordion.$Content.find(".filters");
                            const $toolbar = accordion.$Content.find(".toolbar");
                            if ($filters.length && $toolbar.length) {
                                const $topbar = $("#section-top");
                                const $bottomBar = $("#section-bottom");
                                const topHeight = $topbar.outerHeight();
                                const bottomHeight = $bottomBar.outerHeight();
                                $topbar.addClass("no-box-shadow");
                                $topbar.addClass("with-border-bottom");
                                instance._observers.push(new CS.Helper.CSIntersectionObserver($filters, topHeight, bottomHeight), new CS.Helper.CSIntersectionObserver($toolbar, topHeight, bottomHeight));
                                const onFiltersVisible = () => {
                                    $topbar.addClass("no-box-shadow");
                                    $topbar.addClass("with-border-bottom");
                                };
                                const onFiltersPartiallyHidden = () => {
                                    $topbar.addClass("no-box-shadow");
                                    $topbar.addClass("with-border-bottom");
                                };
                                const onFiltersHidden = () => {
                                    $topbar.removeClass("no-box-shadow");
                                    $topbar.removeClass("with-border-bottom");
                                };
                                instance._observers[0].observeTopIntersections(`${accordion.ControlId}-filters`, onFiltersVisible, onFiltersPartiallyHidden, onFiltersHidden);
                                let toolbarWasVisible = true;
                                let $chips = accordion.$Content.find(".chips");
                                //$chips.css({
                                //    top: `${Math.floor(topHeight) - 1}px`,
                                //});
                                $chips.removeClass("hiddenforced");
                                const onToolbarVisible = () => {
                                    //$chips.addClass("hiddenforced");
                                    //$chips.addClass("xyz-out");
                                    //$chips.removeClass("xyz-in");
                                    toolbarWasVisible = true;
                                };
                                const onToolbarPartiallyHidden = (hiddenRatio, invertedHiddenRatio) => {
                                    if (toolbarWasVisible) {
                                        //$chips.addClass("hiddenforced");
                                        //$chips.addClass("xyz-out");
                                        //$chips.removeClass("xyz-in");
                                    }
                                };
                                const onToolbarHidden = () => {
                                    //$chips.removeClass("hiddenforced");
                                    //$chips.removeClass("xyz-out");
                                    //$chips.addClass("xyz-in");
                                    toolbarWasVisible = false;
                                };
                                instance._observers[1].observeTopIntersections(`${accordion.ControlId}-chips`, onToolbarVisible, onToolbarPartiallyHidden, onToolbarHidden);
                                // Default state avant qu'on commence à scroller
                                $topbar.addClass("no-box-shadow");
                                $topbar.addClass("with-border-bottom");
                                //$chips.addClass("hiddenforced");
                                //$chips.addClass("xyz-out");
                                //$chips.removeClass("xyz-in");
                            }
                        }
                        static clearObservers() {
                            const { instance } = MatchesSection;
                            const { _observers } = instance;
                            if (_observers != null && _observers.length > 0) {
                                for (const key in _observers) {
                                    if (_observers[key]) {
                                        _observers[key].stopObservingTopIntersections();
                                        _observers[key] = null;
                                    }
                                }
                            }
                            instance._observers = [];
                        }
                        static updateFiltersState(state, $elementsContainer, $elementsToToggle, callback) {
                            if (state == "collapsed") {
                                $elementsToToggle.slideUp(150, () => {
                                    if (callback)
                                        callback.call(this);
                                });
                            }
                            else if (state == "expanded") {
                                $elementsToToggle.slideDown(150, () => {
                                    if (callback)
                                        callback.call(this);
                                });
                            }
                            if (state == "collapsed")
                                CS.Lag("matches-wall-toggle-filters", 75, () => $elementsContainer.addClass("collapsed"));
                            else
                                CS.Lag("matches-wall-toggle-filters", 75, () => $elementsContainer.removeClass("collapsed"));
                        }
                        static toggleCustomPresetVisibility(visibilityCondition) {
                            const $dropdown = $("#dropdown-matches-wall-presets");
                            if ($dropdown.length) {
                                const $customPresetItem = $dropdown.find(`.list-item[data-value='${CS.Enumeration.MatchesFiltersPreset.Custom}']`);
                                if ($customPresetItem.length) {
                                    if (visibilityCondition)
                                        $customPresetItem.removeClass("hiddenforced");
                                    else
                                        $customPresetItem.addClass("hiddenforced");
                                }
                            }
                        }
                        static updateUI(accordion) {
                            CS.Helper.log("AccordionMatchesV2", "updateUI", accordion);
                            MatchesSection.setLazyloadingUrl(accordion);
                            //const filtersCounterHtml = DOM.$topBar.find(".filters").html();
                            //const index = filtersCounterHtml.indexOf("(") + 1;
                            //const filtersCount = $("#MatchesV2ActiveFilters").val();
                            //const newFiltersCounterHtml =
                            //  filtersCounterHtml.substring(0, index) +
                            //  filtersCount +
                            //  filtersCounterHtml.substring(index + 1);
                            //const opacity = filtersCount == 0 ? 0 : 1;
                            //DOM.$topBar
                            //  .find(".filters")
                            //  .html(newFiltersCounterHtml)
                            //  .css({ opacity: opacity });
                            const $lazyLoadingTrigger = accordion.$Content.find(".button-lazy-loader-trigger");
                            if ($lazyLoadingTrigger.length)
                                CS.Lag(`${accordion.ControlId}-lazyload`, 500, () => $lazyLoadingTrigger.trigger("click"));
                            const $chipsVisibilityTrigger = accordion.$Content.find(".toolbar");
                            const $chips = CS.DOM.$body.find(`#filters-matches-${accordion.ContentId}-bar .chips`);
                            const $filtersBar = CS.DOM.$body.find(`#filters-matches-${accordion.ContentId}-bar`);
                            if ($chips.length) {
                                $chips.removeClass("hiddenforced");
                            }
                            if ($filtersBar.length && this.isWallLayout) {
                                const topHeight = CS.DOM.$topBar.outerHeight();
                                $filtersBar.css({
                                    top: `${Math.floor(topHeight) - 1}px`,
                                });
                            }
                            MatchesSection.setObservers(accordion);
                        }
                        static setLazyloadingUrl(accordion) {
                            const $lazyloadingUrl = $("#LazyloadingUrl");
                            if ($lazyloadingUrl.length)
                                accordion.Data.RefreshUrl = $lazyloadingUrl.val();
                        }
                        static extractData(extraData, accordion) {
                            const { isCurrent, url: baseUrl, isDisabled, snackbarMessage, } = extraData;
                            const url = MatchesSection.formatSectionUrl(baseUrl, accordion);
                            return {
                                url,
                                isCurrent,
                                isDisabled,
                                snackbarMessage,
                            };
                        }
                        static formatSectionUrl(url, accordion) {
                            const collapsedStateInUrl = url.indexOf("filtersState=Collapsed") > -1;
                            const collapsedStateFits = collapsedStateInUrl == MatchesSection.filtersAreCollapsed;
                            if (!collapsedStateFits) {
                                if (MatchesSection.filtersAreCollapsed) {
                                    url = url.replace("filtersState=Expanded", "filtersState=Collapsed");
                                }
                                else {
                                    url = url.replace("filtersState=Collapsed", "filtersState=Expanded");
                                }
                            }
                            url += "&wallLayout=True";
                            return url;
                        }
                        static removeLazyloadingTrigger(accordion) {
                            accordion.$Content.find(".button-lazy-loader-trigger").remove();
                            accordion.$Content.find(".lazy-loader-trigger").remove();
                        }
                        static appendFiltersCounterInTopBar() {
                            try {
                                //const filtersCount = $("#MatchesV2ActiveFilters").val();
                                //const opacity = filtersCount == 0 ? 0 : 1;
                                //const html = `<div class="filters" style="opacity: ${opacity};">
                                //                <div class="icon ic-cs-filter" data-html=""></div>&nbsp;<span class="label">(${filtersCount})</span>
                                //            </div>`;
                                //const $container = DOM.$topBar.find(
                                //  ".event-dropdown-picker .current-event__name .label"
                                //);
                                //$container.append(html);
                            }
                            catch (e) {
                                console.log(e);
                            }
                        }
                    }
                    WallSections.MatchesSection = MatchesSection;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=matches-section.js.map
